import { Box, Typography, Container } from "@mui/material";

const processSteps = [
  {
    id: "01",
    title: "Initial Consultation",
    text: "We begin by understanding your vision, goals, and needs, followed Antra.",
    img: "/images/consult-a.jpg",
  },
  {
    id: "02",
    title: "Design & Planning",
    text: "Our team creates detailed designs that reflect your requirements.",
    img: "/images/consult-b.jpg",
  },
  {
    id: "03",
    title: "Implementation",
    text: "With carefully selected contractors, we manage every phase.",
    img: "/images/consult-c.jpg",
  },
  {
    id: "04",
    title: "Project Handover",
    text: "Upon completion, we conduct a thorough review, making sure all details.",
    img: "/images/consult-d.jpg",
  },
];

const HowWeWork = () => {
  return (
    <Box sx={{ py: 10,  position: "relative" }}>
      <Container
        maxWidth={false}
        sx={{
          maxWidth: "1450px !important",
          mx: "auto",
          px: { xs: 2, md: 4 },
        }}
      >
        <Typography sx={{ color: "#C29D59",mb:2 }}>How we Work</Typography>
        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            flexDirection: { xs: "column", md: "row" },
            mb: 6,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#fff",
              
              fontSize:{sm:"45px",xs:"28px"},
              mb: { xs: 2, md: 0 },
            }}
          >
            Description{" "}
            <Box component="span" sx={{ color: "#C29D59" }}>
              Architecture <br />Process{" "}
            </Box>
            For Exceptional <br />Results.
          </Typography>

          <Typography
            sx={{
              color: "#b0b0b0ff",
              maxWidth: 450,
              fontSize: "1rem",
              lineHeight: 1.6,
            }}
          >
            Our process is alive – adapting, refining, and growing with your vision. Always. <br />
            Like artists with a blank canvas, we transform rooms into living works of art.
          </Typography>
        </Box>

        {/* Steps Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            gap: 3,
            overflowX: { xs: "auto", md: "visible" },
            pb: { xs: 2, md: 0 },
          }}
        >
          {processSteps.map((step, index) => (
            <Box
              key={step.id}
              sx={{
                flex: "1 1 25%",
                minWidth: { xs: "380px", md: "280px" },
                height:"400px",
                mt:
                  index === 0
                    ? "0px"
                    : index === 1
                    ? "60px"
                    : index === 2
                    ? "120px"
                    : "180px", 
                backgroundColor: "#1d1d1dd6",
                borderRadius: "16px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.05)",
                overflow: "hidden",
                p: 1.8,
                position: "relative",
                fontFamily: 'Helvetica, Arial, sans-serif',
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                },
              }}
            >
              <Box
                component="img"
                src={step.img}
                alt={step.title}
                sx={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  mb: 2,
                }}
              />

              <Typography
                variant="subtitle1"
                sx={{
                  color: "#C29D59",
                  fontFamily: 'Helvetica',
                  fontSize:"20px",
                  fontWeight: 600,
                  mb: 1,
                }}
              >
                {step.id}.{" "}
                <Box component="span" sx={{ color: "#fff", fontWeight: 700 }}>
                  {step.title}
                </Box>
              </Typography>

              <Typography
                sx={{
                  color: "#b0b0b0ff",
                  fontSize: "0.95rem",
                  mb: 4,
                  lineHeight: 1.6,
                }}
              >
                {step.text}
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  position: "absolute",
                  bottom: 10,
                  right: 20,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: "rgba(85, 85, 85, 0.4)",
                  fontWeight: 800,
                  fontSize: "4rem",
                  lineHeight: 1,
                }}
              >
                {step.id}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HowWeWork;
